import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=fe7f05ea&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7f05ea')) {
      api.createRecord('fe7f05ea', component.options)
    } else {
      api.reload('fe7f05ea', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=fe7f05ea&", function () {
      api.rerender('fe7f05ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FiNDHS0Pcbep/JS/comp/childrenage.vue"
export default component.exports